import { AfterViewInit, Directive, ElementRef, OnDestroy, inject } from '@angular/core';
import {OCCURRENCES_RESOURCE_ID, OCCURRENCE_CATEGORY_PREFIX} from '../authenticated/event-calendar/event-calendar.constants';

@Directive({
  selector: '[appStickyOccurrences]',
  standalone: true
})
export class StickyOccurrencesDirective implements AfterViewInit, OnDestroy {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);

  private observer?: MutationObserver;
  private rafHandle?: number;

  ngAfterViewInit() {
    this.rafHandle = requestAnimationFrame(() => {
      this.applyStickyPositions();
      this.setupObserver();
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
    if (this.rafHandle) {
      cancelAnimationFrame(this.rafHandle);
    }
  }

  public refresh(): void {
    this.applyStickyPositions();
    this.setupObserver();
  }

  private applyStickyPositions(): void {
    const container = this.el.nativeElement;
    const tables = container.querySelectorAll('.fc-datagrid-body, .fc-scrollgrid-sync-table');

    tables.forEach((table: Element) => {
      const parentRow = table.querySelector(`tr:has(> td[data-resource-id="${OCCURRENCES_RESOURCE_ID}"])`) as HTMLElement;
      if (!parentRow) return;

      const parentHeight = parentRow.offsetHeight;
      const childRows = table.querySelectorAll(`tr:has(> td[data-resource-id^="${OCCURRENCE_CATEGORY_PREFIX}"])`);
      let cumulativeTop = parentHeight;

      childRows.forEach((row: Element, index: number) => {
        const htmlRow = row as HTMLElement;
        htmlRow.style.top = `${cumulativeTop}px`;

        if (index < childRows.length - 1) {
          cumulativeTop += htmlRow.offsetHeight;
        }
      });
    });

    this.updateSlotWidth();
  }

  private updateSlotWidth(): void {
    const container = this.el.nativeElement;
    const slotsTable = container.querySelector('.fc-timeline-slots table') as HTMLElement;
    if (!slotsTable) return;

    const cols = slotsTable.querySelectorAll('colgroup col');
    if (cols.length === 0) return;

    const tableWidth = slotsTable.offsetWidth;
    const slotWidth = tableWidth / cols.length;

    if (slotWidth > 0) {
      container.style.setProperty('--slot-width', `${slotWidth}px`);
    }
  }

  private setupObserver(): void {
    this.observer?.disconnect();

    const container = this.el.nativeElement;
    const tables = container.querySelectorAll('.fc-datagrid-body, .fc-scrollgrid-sync-table');

    if (tables.length === 0) return;

    this.observer = new MutationObserver(() => {
      this.applyStickyPositions();
    });

    tables.forEach((table: Element) => {
      this.observer?.observe(table, {
        childList: true,
        subtree: true,
      });
    });
  }
}
